module.exports = __webpack_public_path__ + "static/media/answer.61242d75.mp3";